import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	DmstextId: null as number | null,
	NvsprdnPrp: null as boolean | null,
	NvszavdPrp: null as boolean | null,
	OpravadokladPrp: null as boolean | null,
	PnvPrp: null as boolean | null,
	PovPrp: null as boolean | null,
	Poznamka: null as string | null,
	SkladpneuPrp: null as boolean | null,
	TextRtf: null as string | null,
	ZakazkaPrp: null as boolean | null,
	ZlPrp: null as boolean | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
